export default __webpack_public_path__ + "1e38a8b63332881892fbd71680cebbf6.png";